import { Extension } from "@tiptap/core";
import { Editor } from "@tiptap/react";

export const KeyboardShortcuts = (onSave?: (editor: Editor) => void) =>
  Extension.create({
    name: "keyboardShortcuts",

    addKeyboardShortcuts() {
      return {
        "Mod-Enter": () => {
          if (onSave) {
            onSave(this.editor);
            return true;
          }
          return false;
        },
      };
    },
  });
